import { DEFAULT_BUYER_COMMISSION } from 'constants/index'

export const VerificationStatuses = {
  DRAFT: 'draft',
  BLOCKED: 'blocked',
  BASIC_INFO_FILLED: 'basic_info_filled',
  PENDING: 'pending',
  ACCEPTED: 'accepted',
}

export const getProfileVerificationStatusColor = value => {
  switch (value) {
    case VerificationStatuses.ACCEPTED:
      return 'success'
    case VerificationStatuses.PENDING:
      return 'warning'
    case VerificationStatuses.BLOCKED:
      return 'error'
    default:
      return 'info'
  }
}

export const defaultProfileSeller = Object.freeze({
  accountNumber: null,
  commission: 15,
  fee: 19.75,
})

export const AccountType = Object.freeze({
  PERSONAL: 'personal',
  BUSINESS: 'business',
})

/**
 * Resolves the display name for a profile/seller/buyer.
 * Business accounts show the company name; otherwise the full name.
 * Falls back to company if the name is empty (and vice versa).
 * @param {Object} profile - Profile-like object with firstName/lastName/company/accountType
 * @returns {string} Display name (empty string if nothing available)
 */
export const getProfileDisplayName = profile => {
  if (!profile) return ''
  if (profile.accountType === AccountType.BUSINESS && profile.company) return profile.company
  return [profile.firstName, profile.lastName].filter(Boolean).join(' ') || profile.company || ''
}

export const defaultProfileValues = Object.freeze({
  accountType: AccountType.PERSONAL,
  email: '',
  firstName: '',
  company: '',
  lastName: '',
  phone: '',
  country: 'FI',
  commission: DEFAULT_BUYER_COMMISSION,
  identity: {
    address: '',
    country: '',
    zip: '',
  },
  verified: false,
  maxBiddingLevel: null,
  verificationStatus: VerificationStatuses.DRAFT,
  isSeller: false,
  seller: null,
  notifications: {
    winning: false,
    notWinning: true,
  },
})
